export class TokenParser {
  public ParseTokenClaims(token: string) {
    const tokenParts = token.split('.');
    const claimsBase64 = this.padBase64(tokenParts[1]);
    const claimsJson = this.base64DecodeUnicode(claimsBase64);
    const claims = JSON.parse(claimsJson);
    return claims;
  }

  private padBase64(base64data): string {
    while (base64data.length % 4 !== 0) {
      base64data += '=';
    }
    return base64data;
  }

  private base64DecodeUnicode(encodedString: string) {
    const base64 = encodedString.replace(/\-/g, '+').replace(/\_/g, '/');

    return decodeURIComponent(
      atob(base64)
        .split('')
        .map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
  }
}

